export const GOOGLE_API_KEY = import.meta.env.PROD
  ? 'AIzaSyAh5q9v49v_q54wNhwmRdtbJGn5VxCg7q0'
  : 'AIzaSyDgsgbvcjfpaZtxm14aBIQpkT8hHFK2wSo';

/* eslint-disable import/prefer-default-export */
export const waypointHash = (waypoints) => JSON.stringify(waypoints || []);

type WaypointType = {
  lat?: number | string;
  lon?: number | string;
  [key: string]: any;
};

export const normalizeWaypoints = (waypoints): WaypointType[] => {
  if (!Array.isArray(waypoints)) return [];

  return waypoints
    .filter((wp): wp is WaypointType => typeof wp === 'object' && wp !== null)
    .map((wp) => ({
      ...wp,
      lat: typeof wp.lat === 'string' ? Number(wp.lat) : wp.lat,
      lon: typeof wp.lon === 'string' ? Number(wp.lon) : wp.lon,
    }));
};
